import classNames from 'classnames';
import { useMemo, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { JuntaDirectiva as JuntaDirectivaType, Member as MemberType } from '@/interfaces/strapi';

type JuntaDirectivaProps = {
	readonly className?: string;
	readonly data: JuntaDirectivaType[];
};

const classNameComponent = 'c-cnm-junta-directiva';

type MemberCardProps = {
	readonly member: MemberType;
};

const MemberCard = ({ member }: MemberCardProps) => (
	<article className={`${classNameComponent}__member`}>
		<p className={`${classNameComponent}__name`}>{member.name}</p>
		<p className={`${classNameComponent}__position`}>{member.position}</p>
	</article>
);
export const JuntaDirectiva = ({ data, className }: JuntaDirectivaProps): ReactElement => {
	const juntaDirectivaClassName = useMemo(() => classNames(className, classNameComponent), [className]);
	const { t } = useTranslation('translation', { keyPrefix: 'juntaDirectiva' });

	return (
		<section className={juntaDirectivaClassName} role="region">
			{data.map((group) => (
				<section key={group.positionType} className={`${classNameComponent}__group`}>
					<h2 className={`${classNameComponent}__group-title`}>
						{t(`positionType.${group.positionType}`, group.positionType)}
					</h2>
					<div className={`${classNameComponent}__group-members`}>
						{group.members.map((member) => (
							<MemberCard key={member.key} member={member} />
						))}
					</div>
				</section>
			))}
		</section>
	);
};
